module.exports = __webpack_public_path__ + "static/media/js.6dc6899a.png";